import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import useAuthStore from '../store/authStore';
import toast from 'react-hot-toast';

export default function Login() {
  const [form, setForm] = useState({ phone: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { login } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/auth/login', form);
      login(res.data.user, res.data.token);
      toast.success('Connexion réussie !');
      const role = res.data.user.role;
      if (role === 'doctor') navigate('/doctor/dashboard');
      else if (role === 'admin') navigate('/admin/dashboard');
      else navigate('/patient/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-white flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="text-5xl mb-3">🏥</div>
          <h1 className="text-3xl font-bold text-green-700">SantéTogo</h1>
          <p className="text-gray-500 mt-1">Votre santé, notre priorité</p>
          <div className="mt-3 inline-flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-medium">
            <span>💰</span>
            <span>Acompte réservation : 500 FCFA seulement</span>
          </div>
        </div>

        <div className="card">
          <h2 className="text-xl font-bold mb-6 text-gray-800">Connexion</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Numéro de téléphone</label>
              <input className="input-field" type="tel" placeholder="90 00 00 00"
                value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Mot de passe</label>
              <input className="input-field" type="password" placeholder="••••••••"
                value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full py-3">
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>

          <div className="mt-4 text-center space-y-2">
            <p className="text-sm text-gray-600">
              Pas de compte ? <Link to="/register/patient" className="text-green-600 font-semibold">Inscription Patient</Link>
            </p>
            <p className="text-sm text-gray-600">
              Médecin ? <Link to="/register/doctor" className="text-green-600 font-semibold">Inscription Médecin</Link>
            </p>
            <p className="text-sm text-gray-600">
              <Link to="/doctors" className="text-green-600 font-semibold">🔍 Voir les médecins</Link>
            </p>
          </div>
        </div>

        {/* Footer légal */}
        <div className="text-center mt-6 space-y-1">
          <div className="flex justify-center gap-4 text-xs text-gray-400">
            <Link to="/cgv" className="hover:text-green-600 transition-colors">CGV</Link>
            <span>•</span>
            <Link to="/mentions-legales" className="hover:text-green-600 transition-colors">Mentions légales</Link>
            <span>•</span>
            <a href="mailto:support@secury.ovh" className="hover:text-green-600 transition-colors">Contact</a>
          </div>
          <p className="text-xs text-gray-300">© 2026 SantéTogo — M. Sassou-Messan</p>
        </div>
      </div>
    </div>
  );
}
